import { formatPhoneNumber } from "@/components/common/InputFormat";
import type { FindClientBySubQuery } from "@/libs/generated/operations";

import type { DeliveryFormType } from "../types";

type ClientBySub = FindClientBySubQuery["findClientBySub"];

export type MandataireFormData = {
  selectedMandataireId: string;
  selectedOrganizationId: string;
  representativeFirstName: string;
  representativeLastName: string;
  representativeEmail: string;
  representativePhone: string;
  representativeCompany: string;
  representativeSiret: string;
};

/** Extract mandataire/representative fields from the signed-in client profile. */
export function extractMandataireFormData(client: ClientBySub): MandataireFormData {
  return {
    selectedMandataireId: client.id != null ? String(client.id) : "",
    selectedOrganizationId: client.clientOrganization?.slug ?? "",
    representativeFirstName: client.assigneeFirstName ?? "",
    representativeLastName: client.assigneeLastName ?? "",
    representativeEmail: client.assigneeEmail ?? "",
    representativePhone: formatPhoneNumber(client.assigneePhone) || "",
    representativeCompany: client.clientOrganization?.name ?? "",
    representativeSiret: client.siret ?? "",
  };
}

/** Fill step0 mandataire fields (client autofill path). */
export function fillMandataireFormFromClient(form: DeliveryFormType, client: ClientBySub): void {
  const data = extractMandataireFormData(client);
  form.setFieldValue("step0.selectedMandataireId", data.selectedMandataireId);
  form.setFieldValue("step0.selectedOrganizationId", data.selectedOrganizationId);
  form.setFieldValue("step0.representativeFirstName", data.representativeFirstName);
  form.setFieldValue("step0.representativeLastName", data.representativeLastName);
  form.setFieldValue("step0.representativeEmail", data.representativeEmail);
  form.setFieldValue("step0.representativePhone", data.representativePhone);
  form.setFieldValue("step0.representativeCompany", data.representativeCompany);
  form.setFieldValue("step0.representativeSiret", data.representativeSiret);
}
